import './AdminLayout.scss'
import { Outlet, useNavigate } from 'react-router-dom'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { USER_ROLES } from '../../constants/config'

const NAV_ITEMS = {
  0: {
    id: 'zahtjevi',
    title: 'Zahtjevi',
    link: '/admin',
  },
  1: {
    id: 'kategorije',
    title: 'Kategorije',
    link: '/admin/admin-kategorije',
  },
  2: {
    id: 'transferi',
    title: 'Transferi',
    link: '/admin/admin-transferi',
  },
  3: {
    id: 'info',
    title: 'Info',
    link: '/admin/admin-info',
  },
}

export default function AdminLayout() {
  const navigate = useNavigate()

  const userRole = useSelector(state => state.authentication?.userInfo?.role)

  const renderNavigation = useCallback(() => {
    return (
      <div>
        {Object.keys(NAV_ITEMS).map(key => {
          return (
            <a
              href={NAV_ITEMS[key].link}
              key={key}
              className={`navigation-link`}>
              {NAV_ITEMS[key].title}
            </a>
          )
        })}
      </div>
    )
  }, [])

  useEffect(() => {
    // If user is not admin, return
    if (!userRole || userRole !== USER_ROLES.admin) {
      navigate('/')
    }
  }, [userRole])

  return (
    <div id="admin">
      <div className="w-100">
        <div className="d-flex">
          <div className="navigation">{renderNavigation()}</div>
          <div className="content">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
